__turbopack_context__.v({
  "appraiseButton": "styles-module-scss-module__6oKzGq__appraiseButton",
  "auctionBox": "styles-module-scss-module__6oKzGq__auctionBox",
  "bottomRow": "styles-module-scss-module__6oKzGq__bottomRow",
  "brandChips": "styles-module-scss-module__6oKzGq__brandChips",
  "brandHeader": "styles-module-scss-module__6oKzGq__brandHeader",
  "brandLink": "styles-module-scss-module__6oKzGq__brandLink",
  "brandRow": "styles-module-scss-module__6oKzGq__brandRow",
  "brandSize": "styles-module-scss-module__6oKzGq__brandSize",
  "buttonContainer": "styles-module-scss-module__6oKzGq__buttonContainer",
  "buyBox": "styles-module-scss-module__6oKzGq__buyBox",
  "buySection": "styles-module-scss-module__6oKzGq__buySection",
  "carouselContainer": "styles-module-scss-module__6oKzGq__carouselContainer",
  "chipSection": "styles-module-scss-module__6oKzGq__chipSection",
  "close": "styles-module-scss-module__6oKzGq__close",
  "closeContainer": "styles-module-scss-module__6oKzGq__closeContainer",
  "closeIcon": "styles-module-scss-module__6oKzGq__closeIcon",
  "closeTitle": "styles-module-scss-module__6oKzGq__closeTitle",
  "condition": "styles-module-scss-module__6oKzGq__condition",
  "countryInfo": "styles-module-scss-module__6oKzGq__countryInfo",
  "couponCaption": "styles-module-scss-module__6oKzGq__couponCaption",
  "couponCode": "styles-module-scss-module__6oKzGq__couponCode",
  "couponDetail": "styles-module-scss-module__6oKzGq__couponDetail",
  "couponExpiry": "styles-module-scss-module__6oKzGq__couponExpiry",
  "couponItem": "styles-module-scss-module__6oKzGq__couponItem",
  "couponLabel": "styles-module-scss-module__6oKzGq__couponLabel",
  "couponToggle": "styles-module-scss-module__6oKzGq__couponToggle",
  "coupons": "styles-module-scss-module__6oKzGq__coupons",
  "customHeader": "styles-module-scss-module__6oKzGq__customHeader",
  "description": "styles-module-scss-module__6oKzGq__description",
  "descriptionCaption": "styles-module-scss-module__6oKzGq__descriptionCaption",
  "duplicateContent": "styles-module-scss-module__6oKzGq__duplicateContent",
  "duplicateCount": "styles-module-scss-module__6oKzGq__duplicateCount",
  "duplicateErrorRow": "styles-module-scss-module__6oKzGq__duplicateErrorRow",
  "duplicateIcon": "styles-module-scss-module__6oKzGq__duplicateIcon",
  "duplicateLink": "styles-module-scss-module__6oKzGq__duplicateLink",
  "duplicateList": "styles-module-scss-module__6oKzGq__duplicateList",
  "duplicateRetryButton": "styles-module-scss-module__6oKzGq__duplicateRetryButton",
  "duplicateSection": "styles-module-scss-module__6oKzGq__duplicateSection",
  "duplicateStatus": "styles-module-scss-module__6oKzGq__duplicateStatus",
  "favoriteButtonSmall": "styles-module-scss-module__6oKzGq__favoriteButtonSmall",
  "favoriteSection": "styles-module-scss-module__6oKzGq__favoriteSection",
  "favoriteText": "styles-module-scss-module__6oKzGq__favoriteText",
  "followButton": "styles-module-scss-module__6oKzGq__followButton",
  "galleryTransform": "styles-module-scss-module__6oKzGq__galleryTransform",
  "galleryViewport": "styles-module-scss-module__6oKzGq__galleryViewport",
  "headerButton": "styles-module-scss-module__6oKzGq__headerButton",
  "headerButtons": "styles-module-scss-module__6oKzGq__headerButtons",
  "headerRow1": "styles-module-scss-module__6oKzGq__headerRow1",
  "headerRow2": "styles-module-scss-module__6oKzGq__headerRow2",
  "headerSizeGuide": "styles-module-scss-module__6oKzGq__headerSizeGuide",
  "headerSizeInfo": "styles-module-scss-module__6oKzGq__headerSizeInfo",
  "headerTitle": "styles-module-scss-module__6oKzGq__headerTitle",
  "headerTranslate": "styles-module-scss-module__6oKzGq__headerTranslate",
  "image": "styles-module-scss-module__6oKzGq__image",
  "imageContainer": "styles-module-scss-module__6oKzGq__imageContainer",
  "imageSearchButton": "styles-module-scss-module__6oKzGq__imageSearchButton",
  "imageSearchText": "styles-module-scss-module__6oKzGq__imageSearchText",
  "itemSlideIn": "styles-module-scss-module__6oKzGq__itemSlideIn",
  "loadingContainer": "styles-module-scss-module__6oKzGq__loadingContainer",
  "locationRow": "styles-module-scss-module__6oKzGq__locationRow",
  "locationText": "styles-module-scss-module__6oKzGq__locationText",
  "metadataSection": "styles-module-scss-module__6oKzGq__metadataSection",
  "modalText": "styles-module-scss-module__6oKzGq__modalText",
  "price": "styles-module-scss-module__6oKzGq__price",
  "priceBar": "styles-module-scss-module__6oKzGq__priceBar",
  "priceRow": "styles-module-scss-module__6oKzGq__priceRow",
  "priceRowActions": "styles-module-scss-module__6oKzGq__priceRowActions",
  "priceSection": "styles-module-scss-module__6oKzGq__priceSection",
  "priceValue": "styles-module-scss-module__6oKzGq__priceValue",
  "proxies": "styles-module-scss-module__6oKzGq__proxies",
  "proxyLink": "styles-module-scss-module__6oKzGq__proxyLink",
  "proxyOptionsBtn": "styles-module-scss-module__6oKzGq__proxyOptionsBtn",
  "region": "styles-module-scss-module__6oKzGq__region",
  "rentableBox": "styles-module-scss-module__6oKzGq__rentableBox",
  "saveButton": "styles-module-scss-module__6oKzGq__saveButton",
  "shareButton": "styles-module-scss-module__6oKzGq__shareButton",
  "size": "styles-module-scss-module__6oKzGq__size",
  "sizeLink": "styles-module-scss-module__6oKzGq__sizeLink",
  "sizeSection": "styles-module-scss-module__6oKzGq__sizeSection",
  "slideOutCarousel": "styles-module-scss-module__6oKzGq__slideOutCarousel",
  "sold": "styles-module-scss-module__6oKzGq__sold",
  "stats": "styles-module-scss-module__6oKzGq__stats",
  "timeString": "styles-module-scss-module__6oKzGq__timeString",
  "title": "styles-module-scss-module__6oKzGq__title",
  "translateButton": "styles-module-scss-module__6oKzGq__translateButton",
  "translateContainer": "styles-module-scss-module__6oKzGq__translateContainer",
  "vendor": "styles-module-scss-module__6oKzGq__vendor",
  "vendorInfo": "styles-module-scss-module__6oKzGq__vendorInfo",
  "vendorLink": "styles-module-scss-module__6oKzGq__vendorLink",
  "vendorRegion": "styles-module-scss-module__6oKzGq__vendorRegion",
  "warning": "styles-module-scss-module__6oKzGq__warning",
  "warningChip": "styles-module-scss-module__6oKzGq__warningChip",
  "zoomContainer": "styles-module-scss-module__6oKzGq__zoomContainer",
});
